import { getCurrentInstance } from 'vue'
import { ColorEnum, CtrPerformanceLevelEnum } from '../../enums'

interface CtrPerformanceLegendItem {
  label: string
  color: string
}

interface UseToolingReportCtrPerformance {
  ctrPerformanceLegendItems: CtrPerformanceLegendItem[]
  getBarColor: (ctr: number, avg: number) => ColorEnum
  getCtrPerformanceLevel: (ctr: number, avg: number) => CtrPerformanceLevelEnum
}

export function useToolingReportCtrPerformance(): UseToolingReportCtrPerformance {
  const {
    proxy: { $epb },
  } = getCurrentInstance() as { proxy: Vue }
  const messages = $epb.messages.insights.toolReporting

  const ctrPerformanceLegendItems: CtrPerformanceLegendItem[] = [
    {
      label: messages.ctrPerformance.high.label,
      color: ColorEnum.GREEN_75,
    },
    {
      label: messages.ctrPerformance.medium.label,
      color: ColorEnum.YELLOW_75,
    },
    {
      label: messages.ctrPerformance.low.label,
      color: ColorEnum.RED_75,
    },
  ]
  const ctrPerformanceLevelToColorMap = {
    [CtrPerformanceLevelEnum.LOW]: ColorEnum.RED_75,
    [CtrPerformanceLevelEnum.MEDIUM]: ColorEnum.YELLOW_75,
    [CtrPerformanceLevelEnum.HIGH]: ColorEnum.GREEN_75,
  }

  function getCtrPerformanceLevel(ctr: number, avg: number): CtrPerformanceLevelEnum {
    const avgQuarter = avg * 0.25

    if (ctr < avgQuarter) {
      return CtrPerformanceLevelEnum.LOW
    }
    if (ctr >= avgQuarter && ctr <= avg) {
      return CtrPerformanceLevelEnum.MEDIUM
    }
    return CtrPerformanceLevelEnum.HIGH
  }

  function getBarColor(ctr: number, avg: number): ColorEnum {
    return ctrPerformanceLevelToColorMap[getCtrPerformanceLevel(ctr, avg)]
  }

  return { ctrPerformanceLegendItems, getBarColor, getCtrPerformanceLevel }
}
